import { combineReducers } from 'redux';
import {
  FETCHING_HUB_LAYOUT_REQUEST, FETCHING_HUB_LAYOUT_SUCCEDDED, FETCHING_HUB_LAYOUT_FAILED, INVALIDATE_HUB_LAYOUT,
  FETCHING_HUB_LAYOUTS_REQUEST, FETCHING_HUB_LAYOUTS_SUCCEEDED, FETCHING_HUB_LAYOUTS_FAILED,
  UPDATING_HUB_LAYOUT_REQUEST, UPDATING_HUB_LAYOUT_SUCCEEDED, UPDATING_HUB_LAYOUT_FAILED, REARRANGING_HUB_LAYOUT_SUCCEEDED,
  DELETING_HUB_ROW_REQUEST, DELETING_HUB_ROW_SUCCEEDED,
  FETCHING_HUB_SECTION_REQUEST, FETCHING_HUB_SECTION_SUCCEDDED, FETCHING_HUB_SECTION_FAILED, INVALIDATE_HUB_SECTION,
  FETCHING_HUB_STREAMS, FETCHING_HUB_STREAMS_SUCCEDDED, FETCHING_HUB_STREAMS_FAILED, INVALIDATE_HUB_STREAMS,

  DELETING_STREAM_SUCCEDDED, UPDATING_STREAM_SUCCEDDED,
  CREATING_GROUP_SUCCEDDED, CREATING_GROUP_PARENT_GROUP_SUCCEDDED,
  ADD_ASSET_TO_STREAM_SUCCEDDED, REMOVE_ASSET_FROM_STREAM_SUCCEDDED,
  CREATE_STREAM, CREATE_STREAM_SUCCEDDED, CREATE_STREAM_FAILED, INVALIDATE_CREATE_STREAM_ERRORS,
  TOGGLE_EDIT_HUB_SECTION, UPDATE_HUB_SECTION_CONTENTS, UPDATING_HUB_SECTION_CONTENTS_SUCCEEDED, 
  UPDATING_HUB_SECTION_CONTENTS_FAILED,
  UPDATING_HUB_SECTION_FAILED, UPDATING_HUB_SECTION_SUCCEEDED, UPDATING_HUB_SECTION_REQUEST,
  CREATING_HUB_SECTION_REQUEST, CREATING_HUB_SECTION_SUCCEEDED, 
  ENABLING_ACCESS_FOR_USER_GROUPS, ENABLING_ACCESS_FOR_USER_GROUPS_SUCCEEDED, ENABLING_ACCESS_FOR_USER_GROUPS_FAILED,
  DELETING_HUB_LAYOUT_REQUEST, DELETING_HUB_LAYOUT_SUCCEEDED, DELETING_HUB_LAYOUT_FAILED

} from '../actions/actionTypes.jsx';

import { orderBy } from 'natural-orderby';
import _ from "lodash";

const initialState = {
  loading: false,
  invalidated: true,
  items: []
};

const initialLayoutState = {
  loading: true,
  invalidated: true,
  item: null,
  rearranged: false
};

const initialSectionState = {
  loading: true,
  invalidated: true,
  items: null,
};

const streamsInitialState = {
  loading: false,
  invalidated: true,
  items: [],
  createStream: {
    creating: false,
    error: null
  }
}

function createCommonReducer(resourceName) {
  return function counter(state = initialState, action) {
    switch (action.type) {
      case `FETCHING_${resourceName}`:
        return Object.assign({}, state, {
          loading: true,
          invalidated: true
        })
      case `FETCHING_${resourceName}_SUCCEDDED`:
        return Object.assign({}, state, {
          loading: false,
          invalidated: false,
          items: action.payload
        })
      case `FETCHING_${resourceName}_FAILED`:
        return Object.assign({}, state, {
          loading: false,
          invalidated: false
        })
      case `INVALIDATE_${resourceName}`:
        return Object.assign({}, state, {
          loading: false,
          invalidated: true
        })

      default:
        return state
    }
  }
}

function layoutReducer() {
  return function reducer(state = initialLayoutState, action) {
    switch (action.type) {
      case FETCHING_HUB_LAYOUT_REQUEST:
        return Object.assign({}, state, {
          loading: true,
          invalidated: true
        })

      case FETCHING_HUB_LAYOUT_SUCCEDDED:
        return Object.assign({}, state, {
          loading: false,
          invalidated: false,
          item: action.payload
        })

      case FETCHING_HUB_LAYOUT_FAILED:
        return Object.assign({}, state, {
          loading: false,
          invalidated: false
        })

      case FETCHING_HUB_LAYOUTS_REQUEST:
        return Object.assign({}, state, {
          loading: true,
          invalidated: true
        })

      case FETCHING_HUB_LAYOUTS_SUCCEEDED:
        return Object.assign({}, state, {
          loading: false,
          invalidated: false,
          layouts: action.payload
        })

      case FETCHING_HUB_LAYOUTS_FAILED:
        return Object.assign({}, state, {
          loading: false,
          invalidated: false,
          error: action.payload
        })

      case INVALIDATE_HUB_LAYOUT:
        return Object.assign({}, state, {
          loading: false,
          invalidated: true
        })
      
      case REARRANGING_HUB_LAYOUT_SUCCEEDED:
        var index = action.payload.index;
        var direction = action.payload.direction;

        var rows = state.item.rows;
        if((index == 0 && direction == "up") || (index == state.item.rows.length - 1 && direction == "down")){
          rows = rows;
        } else {
          var row = rows.splice(index, 1)[0];
          rows.splice(direction == "up" ? index - 1 : index + 1, 0, row);
        }

        return Object.assign({}, state, {
          loading: false,
          invalidated: false,
          item: {
            ...state.item,
            rows: rows,
          },
          rearranged: true
        })
      
      case UPDATING_HUB_LAYOUT_REQUEST:
        return Object.assign({}, state, {
          loading: true
        })

      case UPDATING_HUB_LAYOUT_SUCCEEDED:
        return Object.assign({}, state, {
          loading: false,
          invalidated: false,
          item: action.payload,
          rearranged: false
        })

      case UPDATING_HUB_LAYOUT_FAILED:
        return Object.assign({}, state, {
          loading: false,
          invalidated: false,
          error: action.payload.error
        })
      
      case DELETING_HUB_ROW_REQUEST:
        return Object.assign({}, state, {
          deleting: true
        })

      case DELETING_HUB_ROW_SUCCEEDED:
        var index = action.payload.index;
        
        var updatedRows =  state.item.rows.filter((row, i) => {
          return i != index
        })

        return Object.assign({}, state, {
          deleting: false,
          item: {
            ...state.item,
            rows: updatedRows
          }
        })

      case UPDATING_HUB_SECTION_REQUEST:
        return Object.assign({}, state, {
          ...state,
          item:{
            ...state.item,
            updating: true
          }
        })

      case UPDATING_HUB_SECTION_SUCCEEDED:
        var response = action.payload.response;
        var rowIndex = action.payload.rowIndex;
        var create = action.payload.create;

        if (create) {
          state.item.rows.splice(rowIndex, 0, response);
        } else {
          state.item.rows[rowIndex] = response;
        }

        return Object.assign({}, state, {
          ...state,
          item: {
            ...state.item,
            rows: state.item.rows
          }
        })

      case UPDATING_HUB_SECTION_FAILED: 
      console.log(action.payload)

      case CREATING_HUB_SECTION_REQUEST:
        return Object.assign({}, state, {
          ...state,
          creating: true
        })

      case CREATING_HUB_SECTION_SUCCEEDED:
        var row = action.payload.row;
        var response = action.payload.response;
        var rowIndex = action.payload.rowIndex;

        var columns = [];
        
        columns.push({
          width: row.columns[0].width,
          section: response
        })

        var updatedRow = {
          columns: columns
        }

        state.item.rows.splice(rowIndex, 0, updatedRow);

        return Object.assign({}, state, {
          ...state,
          item: {
            ...state.item,
            rows: state.item.rows
          }
        })

      case DELETING_HUB_LAYOUT_REQUEST:
        return Object.assign({}, state, {
          ...state,
          deleting: true
        })

      case DELETING_HUB_LAYOUT_FAILED:
        return Object.assign({}, state, {
          ...state,
          deleting: false,
          error: _.get(action,"paylaod.error","")
        })

      case ENABLING_ACCESS_FOR_USER_GROUPS:
        return Object.assign({}, state, {
          ...state,
          enablingAccess: true
        })

      case ENABLING_ACCESS_FOR_USER_GROUPS_SUCCEEDED:
        var index = _.findIndex(state.layouts, layout => layout.id === action.payload.id);
        var layouts = state.layouts;

        layouts[index] = action.payload;

        return Object.assign({}, state, {
          ...state,
          layouts: layouts,
          enablingAccess: false
        })

      case ENABLING_ACCESS_FOR_USER_GROUPS_FAILED:
        return Object.assign({}, state, {
          ...state,
          error: _.get(action,"paylaod.error",""),
          enablingAccess: false
        })

      default:
        return state
    }
  }
}

function sectionReducer() {
  return function reducer(state = {}, action) {
    switch (action.type) {
      case FETCHING_HUB_SECTION_REQUEST:
        var id = action.payload.id;
        var section = state[id] || initialSectionState;

        return Object.assign({}, state, {
          ...state,
          [id]: {
            ...section,
            loading: true,
            invalidated: true
          }
        })

      case FETCHING_HUB_SECTION_SUCCEDDED:
        var id = action.payload.id;
        var section = state[id] || initialSectionState;
        var items = action.payload.response.items != null ? action.payload.response.items : action.payload.response.recommendedCategories;
        var smartFilter = action.payload.response.smartFilter;

        if (id == "streams") {
          var sortByName = items.filter(item => {
            return item.lastViewed == null;
          });

          var sortByView = items.filter(item => {
            return item.lastViewed != null;
          });

          sortByName = orderBy(sortByName, [sortByName => sortByName.name]);
          sortByView = orderBy(sortByView, [sortByView => sortByView.lastViewed], ['desc']);

          items = [...sortByView, ...sortByName];
        }

        return Object.assign({}, state, {
          ...state,
          [id]: {
            ...section,
            loading: false,
            invalidated: false,
            items: items,
            smartFilter: smartFilter
          }
        })

      case FETCHING_HUB_SECTION_FAILED:
        var id = action.payload.id;
        var section = state[id] || initialSectionState;

        return Object.assign({}, state, {
          ...state,
          [id]: {
            ...section,
            loading: false,
            invalidated: false,
            items: null,
            error: action.payload.error
          }
        })

      case INVALIDATE_HUB_SECTION:
        return Object.assign({}, state, {
          loading: false,
          invalidated: true
        })

      case DELETING_STREAM_SUCCEDDED:
        var streamId = action.payload;

        var items = state.streams && state.streams.items && state.streams.items.filter(item => {
          return item.id !== streamId;
        });

        return Object.assign({}, state, {
          ...state,
          streams: {
            ...state.streams,
            items: items
          }
        })

      case TOGGLE_EDIT_HUB_SECTION:
        return Object.assign({}, state, {
          ...state,
          canEditLayout: action.payload
        })

      case UPDATE_HUB_SECTION_CONTENTS:
        var id = action.payload.sectionId;
        var section = state[id] || initialSectionState;
        return Object.assign({}, state, {
          [id]: {
            ...section,
            updating: true,
            error: action.payload.error
          }
        })

      case UPDATING_HUB_SECTION_CONTENTS_SUCCEEDED:
        var id = action.payload.sectionId;
        var section = state[id] || initialSectionState;

        return Object.assign({}, state, {
          [id]: {
            ...section,
            updating: false,
            items: action.payload.contents
          }
        })

      case UPDATING_HUB_SECTION_CONTENTS_FAILED:
        return Object.assign({}, state, {
          ...state,
          updating: false,
          error: action.payload
        })

      default:
        return state
    }
  }
}


function streamsReducer() {
  return function counter(state = streamsInitialState, action) {
    switch (action.type) {
      case FETCHING_HUB_STREAMS:
        return Object.assign({}, state, {
          loading: true,
          invalidated: true
        })
      case FETCHING_HUB_STREAMS_SUCCEDDED:
        return Object.assign({}, state, {
          loading: false,
          invalidated: false,
          items: _.sortBy(action.payload, 'name')
        })
      case FETCHING_HUB_STREAMS_FAILED:
        return Object.assign({}, state, {
          loading: false,
          invalidated: false
        })
      case INVALIDATE_HUB_STREAMS:
        return Object.assign({}, state, {
          loading: false,
          invalidated: true
        })

      case CREATE_STREAM:
        return Object.assign({}, state, {
          ...state,
          createStream: {
            creating: true,
            error: null
          }
        })

      case CREATE_STREAM_SUCCEDDED:
        var streams = state.items.slice();
        
        streams.splice(streams.length, 0, action.payload);

        let uniqueItems = new Set(streams).toJSON();

        return Object.assign({}, state, {
          ...state,
          items: uniqueItems.sort((a, b) => {
            return a.name > b.name ? 1 : a.name < b.name ? -1 : 0;
          }),
          createStream: {
            creating: false,
            error: null
          }
        })

      case CREATE_STREAM_FAILED:
        return Object.assign({}, state, {
          ...state,
          createStream: {
            creating: false,
            error: action.payload
          }
        })

      case INVALIDATE_CREATE_STREAM_ERRORS:
        return Object.assign({}, state, {
          ...state,
          createStream: {
            creating: false,
            error: null
          }
        })

      case DELETING_STREAM_SUCCEDDED:
        var items = state.items && state.items.filter((item) => {
          return item.id != action.payload
        })

        return Object.assign({}, state, {
          loading: false,
          invalidated: false,
          items: items
        })
      case UPDATING_STREAM_SUCCEDDED:
        var id = action.payload.id;

        return Object.assign({}, state, {
          ...state,
          items: state.items.map((stream, index) => {
            if (stream.id != id) {
              return stream;
            }

            return {
              ...action.payload.stream
            };
          })
        })

      case CREATING_GROUP_SUCCEDDED:
        var id = action.payload.streamId;
        return Object.assign({}, state, {
          ...state,
          items: state.items.map((stream, index) => {
            if (stream.id != id) {
              return stream;
            }

            return {
              ...stream,
              groups: stream.groups + 1
            };
          })
        })

      case CREATING_GROUP_PARENT_GROUP_SUCCEDDED:
        var id = action.payload.streamId;
        return Object.assign({}, state, {
          ...state,
          items: state.items.map((stream, index) => {
            if (stream.id != id) {
              return stream;
            }

            return {
              ...stream,
              groups: stream.groups + 1
            };
          })
        })

      case ADD_ASSET_TO_STREAM_SUCCEDDED:
        var id = action.payload.streamId;
        return Object.assign({}, state, {
          ...state,
          items: state.items.map((stream, index) => {
            if (stream.id != id) {
              return stream;
            }

            return {
              ...stream,
              assets: stream.assets + action.payload.asset.length,
            };
          })
        })

      case REMOVE_ASSET_FROM_STREAM_SUCCEDDED:
        var id = action.payload.streamId;
        return Object.assign({}, state, {
          ...state,
          items: state.items.map((stream, index) => {
            if (stream.id != id) {
              return stream;
            }

            return {
              ...stream,
              assets: stream.assets - action.payload.asset.length,
            };
          })
        })


      default:
        return state
    }
  }
}

const hubReducer = combineReducers({
  layout: layoutReducer(),
  sections: sectionReducer(),
  streams: streamsReducer(),
  recommendedStreams: createCommonReducer('RECOMMENDED_STREAMS'),
  assets: combineReducers({
    mostViewed: createCommonReducer('HUB_MOST_VIEWED_ASSETS'),
    recent: createCommonReducer('HUB_RECENT_ASSETS'),
    recommended: createCommonReducer('HUB_RECOMMENDED_ASSETS'),
    recentlyViewed: createCommonReducer('HUB_RECENTLY_VIEWED_ASSETS'),
    recommendedAssets: createCommonReducer('HUB_RECOMMENDED_ASSETS')
  })
})

export { hubReducer };